<ion-content class="login-content">
  <div class="modal-backdrop-click">
    <div class="page-container">
      <!-- Login Card -->
      <div class="login-card">
      <button
        type="button"
        class="modal-close"
        (click)="back()"
        [disabled]="load || loadGoogle"
        [class.close-disabled]="load || loadGoogle"
        aria-label="Fechar">
        <ion-icon name="close"></ion-icon>
      </button>
      <!-- Logo Section -->
      <div class="logo-section">
        <div class="logo-container">
          <img src="../../../assets/logo.png" alt="iPlanta Logo" class="main-logo" />
        </div>
      </div>

      <!-- Welcome Content -->
      <div class="welcome-content">
        <h1 class="welcome-title">Bem-vindo de volta!</h1>
        <p class="welcome-subtitle">Entre com suas credenciais para continuar</p>
      </div>

      <!-- Login Form -->
      <form class="login-form" [class.form-disabled]="load">
        <div class="input-group">
          <ion-item class="login-input" [class.input-disabled]="load" lines="none">
            <ion-icon name="mail-outline" slot="start"></ion-icon>
            <input
              class="login-input-native"
              data-testid="login-email-input"
              [(ngModel)]="user.email"
              type="email"
              placeholder="Email"
              (input)="changeEmail()"
              [disabled]="load"
            />
          </ion-item>
          <div class="error-message" data-testid="login-email-error" *ngIf="messageErrorEmail.status && !load">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <span>{{messageErrorEmail.message}}</span>
          </div>
        </div>

        <div class="input-group">
          <ion-item class="login-input" [class.input-disabled]="load" lines="none">
            <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
            <input
              class="login-input-native"
              data-testid="login-password-input"
              [(ngModel)]="user.password"
              [attr.type]="showPassword ? 'text' : 'password'"
              placeholder="Senha"
              (input)="changePass()"
              [disabled]="load"
            />
            <ion-button fill="clear" slot="end" (click)="showPassword = !showPassword" type="button" [disabled]="load">
              <ion-icon [hidden]="showPassword" name="eye-off-outline"></ion-icon>
              <ion-icon [hidden]="!showPassword" name="eye-outline"></ion-icon>
            </ion-button>
          </ion-item>
          <div class="error-message" data-testid="login-password-error" *ngIf="messageErrorPass.status && !load">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <span>{{messageErrorPass.message}}</span>
          </div>
          <p
            *ngIf="!load"
            class="recover-link"
            (click)="requestPasswordRecover()">
            Recupere sua senha aqui
          </p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <ion-button
            [disabled]="!user.password || !user.email || load"
            class="login-button"
            [class.loading]="load"
            (click)="login(user)"
            id="login"
            data-testid="login-submit-btn"
            expand="block">
            <ion-spinner *ngIf="load" name="crescent" slot="start"></ion-spinner>
            <ion-icon *ngIf="!load" name="log-in-outline" slot="start"></ion-icon>
            {{ load ? 'Entrando...' : 'Entrar' }}
          </ion-button>

          <div class="login-divider" *ngIf="!load">
            <span>ou</span>
          </div>

          <ion-button
            *ngIf="!load"
            class="google-button"
            (click)="loginWithGoogle()"
            [disabled]="loadGoogle"
            expand="block"
            fill="outline">
            <ion-spinner *ngIf="loadGoogle" name="crescent" class="google-spinner"></ion-spinner>
            <img *ngIf="!loadGoogle" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" class="google-icon" />
            {{ loadGoogle ? 'Entrando...' : 'Entrar com Google' }}
          </ion-button>

          <ion-button
            *ngIf="!load"
            class="signup-button"
            data-testid="login-signup-btn"
            (click)="singUpPage()"
            expand="block">
            <ion-icon name="person-add-outline" slot="start"></ion-icon>
            Criar Conta
          </ion-button>
        </div>
      </form>

      <!-- Terms Link -->
      <div class="terms-section">
        <a routerLink="/terms" class="terms-link" (click)="back()">
          <ion-icon name="document-text-outline"></ion-icon>
          Termos de uso e políticas de privacidade
        </a>
      </div>

      <!-- App Version -->
      <p class="app-version-label">Versão {{ appVersion }}</p>
    </div>
  </div>
  </div>
</ion-content>
